"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiRadioThemeOptions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const radio_checked_icon_1 = require("./mui-radio-theme-options/radio-checked-icon");
const radio_unchecked_icon_1 = require("./mui-radio-theme-options/radio-unchecked-icon");
const focusBorderOffset = 4;
const focusBorderWidth = 2;
exports.MuiRadioThemeOptions = {
    defaultProps: {
        disableRipple: true,
        disableFocusRipple: true,
        disableTouchRipple: true,
        icon: (0, jsx_runtime_1.jsx)(radio_unchecked_icon_1.RadioUncheckedIcon, {}),
        checkedIcon: (0, jsx_runtime_1.jsx)(radio_checked_icon_1.RadioCheckedIcon, {}),
    },
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.gray[40],
            padding: 0,
            [`&.Mui-focusVisible:after, &:focus-visible:after`]: {
                content: `""`,
                border: "2px solid red",
                position: "absolute",
                top: -focusBorderOffset,
                left: -focusBorderOffset,
                right: -focusBorderOffset,
                bottom: -focusBorderOffset,
                borderWidth: focusBorderWidth,
                borderColor: theme.palette.blue[70],
                borderRadius: "50%",
            },
        }),
    },
};
